import { usePrevious } from "@sail/react";
import key from "./key";
import useLocalStorage from "../../public/localStorage/useLocalStorage";
export default function useOnChangedUser(callback) {
    const [loggedUser] = useLocalStorage(key);
    const previous = usePrevious(loggedUser);
    if (loggedUser && previous && loggedUser !== previous) {
        callback();
    }
}

//# sourceMappingURL=useOnChangedUser.js.map